import { fetchBase } from "./fetchBase";
import type { FetchMethod, FetchOptions, SettingsOptions } from "./types";

export const fetchBlob = async (
  url: string,
  method: FetchMethod,
  params: Record<string, any> = {},
  options: FetchOptions = {},
  settings: SettingsOptions = { setContentType: false, fetchBlobType: true }
): Promise<Blob> => {
  const response = await fetchBase(url, method, params, options, settings);
  return await response.blob();
};
